import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import TeamMatchupImage from '@mlb/react-patterns/v4/components/TeamMatchupImage/teamMatchupImage';
// import { getGameStoryThumbnailUrl } from '@gameday/utils/getGameStoryThumbnailUrl';

import {
    GameStoryThumbnailWrapper
} from './GameStoryThumbnail.style';

import { withTheme } from 'styled-components';

const srcSetWidth = {
    '1x': 121,
    '2x': 242,
    '3x': 363
};

const GameStoryThumbnail = ({
    away,
    home
}) => {

    return (
        <GameStoryThumbnailWrapper>
            <TeamMatchupImage
                awayTeamId={ away }
                homeTeamId={ home }
                ratio='121:168'
                srcsetWidth={ srcSetWidth }
                srcWidth={ srcSetWidth['1x'] }
                borderRadius={ '7px'}
             />
        </GameStoryThumbnailWrapper>
    );
};

GameStoryThumbnail.propTypes = {
    away: PropTypes.number.isRequired,
    home: PropTypes.number.isRequired
};

export default withTheme(GameStoryThumbnail);
